import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { UserProfile } from 'src/app/models/profile.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'about-me-field',
    templateUrl: './about-me-field.component.html',
    styleUrl: './about-me-field.component.scss',
    standalone: false
})
export class AboutMeFieldComponent implements OnChanges, OnInit {
  @Input() description : string = '';
  @Input() userInfo : UserProfile;
  @Input() isStreapper: boolean = false;

  editMode: boolean = false;
  loading : boolean = true;
  publishing: boolean = false;

  profileFormGroup: UntypedFormGroup;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private readonly materialSnackbar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.profileFormGroup = this._formBuilder.group({
      aboutme: [
        { value: this.description, disabled: true },
        [Validators.required, Validators.maxLength(500)],
      ],
    });

    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.description && this.description && this.profileFormGroup) {
      this.profileFormGroup.patchValue({
        aboutme: this.description,
      });
    }

    if (changes.userInfo && this.userInfo) {
      this.isStreapper = this.authService.isStreapper;
    }
  }

  cancel() : void {
    this.profileFormGroup.get('aboutme').disable();

    this.profileFormGroup.reset({
      aboutme: this.description
    });

    this.editMode = false;
  }

  edit() : void {
    this.profileFormGroup.get('aboutme').enable();

    this.editMode = true;
  }

  async save(): Promise<void> {
    if(this.publishing)
      return;

    if(this.profileFormGroup.dirty && this.profileFormGroup.valid && this.isStreapper) {
      this.publishing = true;

      //Have to send birthday with it for some reason atm, TODO: change minimum requirements for updating profile
      var aboutMe = { 
        profile: this.profileFormGroup.get('aboutme').value,
        birthday: this.userInfo.birthDay //tmp, need to change back-end
      };

      try {
        await this.authService.updateProfile(JSON.stringify(aboutMe));

        this.profileFormGroup.get('aboutme').disable();

        this.description = this.profileFormGroup.get('aboutme').value;

        this.materialSnackbar.open(
          `Uw wijzingen zijn opgeslagen!`,
          'Ok',
          {
            duration: 5000,
            panelClass: "snackbar-successful",
          }
        );

        this.editMode = false;

        this.authService.loginSilent().then(() => {
          this.editMode = false;
        });
      } catch (error) {
        console.error('Error saving about me:', error);

        this.materialSnackbar.open(
          `Er is een fout opgetreden bij het opslaan van uw wijzigingen`,
          'Ok',
          {
            duration: 5000,
            panelClass: "snackbar-fail",
          }
        );
      }

      this.publishing = false;
    } else {
      this.cancel();
    }
  }

  getFabStyle(): string {
    if (this.profileFormGroup.dirty && this.profileFormGroup.valid) {
      return 'active';
    } else {
      return '';
    }
  }
}
